const SPECIAL_SCHEME_RE = /^(mailto|tel):/i;

export function isExternalUrl(url: string): boolean {
  return /^(?:https?:)?\/\//i.test(url);
}

export function toAbsoluteUrl(url: string): string {
  if (isExternalUrl(url)) return url;
  if (SPECIAL_SCHEME_RE.test(url)) return url;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  if (url.startsWith('/')) return `${origin}${url}`;
  return `${origin}/${url}`;
}

export function navigateTo(url: string): void {
  window.location.href = toAbsoluteUrl(url);
}
